<ion-row class="phi-align-items-center">
  <ion-col size>
    <h4 class="ml-10 fw-b">Add Comment</h4>
  </ion-col>
  <ion-col size="auto">
    <button matButton mat-dialog-close class="dialog_btns close_btn"><ion-icon name="close-outline"></ion-icon></button>
  </ion-col>
</ion-row>

<mat-dialog-content>
  Please provide the reason for {{ matDialogData === 'Rejected' ? 'rejection' : 'approval'}}.
  <textarea rows="3" cols="4" class="min-w-sm-150 w-100 mt-10 mb-5" [(ngModel)]="managerComment"></textarea>
  <p *ngIf="showErrorMsg" class="red fs-14">Please add comment for {{ matDialogData === 'Rejected' ? 'rejection' : 'approval'}}</p>
</mat-dialog-content>
<mat-dialog-actions class="p-0">
  <div class="pl-20 pb-20 pr-20">
    <button type="button" matButton (click)="closeModal()" class="add_btn">Submit</button>
  </div>
</mat-dialog-actions>